<template>
  <v-container fluid style="padding:0">
    <section style="padding:0">
      <Masterhead />
    </section>

    <section class="section--light">
      <h2>Aménagez vos espaces extérieurs <br/>sur la première plateforme d'aménagement paysager en ligne.</h2>
      <br/>
      <h3>
        Une communauté de paysagistes passionnés<br/>pour dessiner le jardin de vos rêves<br/>en fonction de votre style et de vos envies.
      </h3>
    </section>
    
    <section>
      <Ccm/>
    </section>

    <section class="section--light">
      <Users/>
    </section>

    <section>
      <Todo/>
    </section>

    <section class="section--light">
      <More/>
    </section>

    <section>
      <Commit/>
    </section>

    <section class="section--light">
      <Partners/>
    </section>

    <section>
      <Us/>
    </section>

    <section class="section--light">
      <About/>
    </section>

    <section style="height:300px;background:#333">
    </section>

    <v-btn
      color="green"
      class="fab-project"
      dark
      fixed
      bottom
      right
      fab
      @click="$router.push('/mon-projet')"
    >
      Créer<br/>mon<br/>projet
    </v-btn>

  </v-container>
  
</template>

<script>
// @ is an alias to /src

import Ccm from '../components/home/Ccm'
import Todo from '../components/home/Todo'
import Users from '../components/home/Users'
import More from '../components/home/More'
import Commit from '../components/home/Commit'
import Partners from '../components/home/Partners'
import Us from '../components/home/Us'
import About from '../components/home/About'
import Masterhead from '../components/home/Masterhead'

export default {
  name: 'Home',

  components: {
    Ccm,
    Users,
    Todo,
    More,
    Commit,
    Partners,
    Us,
    About,
    Masterhead
  }
}
</script>

<style scoped>
section {
  padding: 3em 0;
}

.section--light {
  color: #3E524F;
  background-color:#d3e8db;
  text-align:center;
  padding: 2em 0;
}

.fab-project {
  width:120px;
  height:120px;
  right:5%;
  font-size:18px;
}

@media (min-width: 600px) {
  .fab-project {
    width:180px;
    height:180px;
    font-size:23px;
  }
}
</style>